/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Data Controls
import { NgcDataTableModule } from '../controls/datatable/ngc-datatable.component';
import { NgcGridModule } from '../controls/grid/ngc-grid.component';

/**
 * NGC Data Module
 */

export class NgcDataModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [
        NgcDataTableModule,
        NgcGridModule
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
